<script>
import {showTeacherCourseList} from "@/utils/apis";
import MaterialExam from "@/components/material/MaterialExam.vue";
import {mapActions} from "vuex"

export default {
    data() {
        return {
            course_list: [],
        }
    },
    components: {
        MaterialExam,
    },
    computed: {
        courseId: {
            get() {
                return this.$store.state.courseId;
            },
            set(val) {
                this.$store.commit("SET_COURSE_ID", val)
            }
        }
    },
    methods: {
        ...mapActions([
            'updateCourseId'
        ]),
        courseListData() {
            showTeacherCourseList().then(({code, data, msg}) => {
                if (code === 200) {
                    this.course_list = data.course_list || [];
                    const ids = this.course_list.map((c) => Number(c.course_id));
                    const current = this.courseId != null ? Number(this.courseId) : null;
                    const valid = current != null && ids.includes(current);
                    if (!valid && this.course_list.length) {
                        this.updateCourseId(this.course_list[0].course_id);
                        this.$nextTick(() => this.$refs.examRefs && this.$refs.examRefs.updateData());
                    } else if (!valid && !this.course_list.length) {
                        this.$store.commit("CLEAR_COURSE_RESOURCE");
                    }
                }
            })
        },
        handleChange(val) {
            this.$refs.examRefs.updateData()
        }
    },
    mounted() {
        this.courseListData()
    }
}

</script>

<template>
    <div class="teach-container">
        <div class="container">
            <div class="course-list">
                <div class="label">课程：</div>
                <el-select size="small" v-model="courseId" @change="handleChange">
                    <el-option v-for="(value, index) in course_list" :key="index" :label="value.course_name" :value="value.course_id"></el-option>
                </el-select>
            </div>
            <material-exam ref="examRefs" style="height: calc(100% - 50px);"/>
        </div>
    </div>

</template>

<style scoped lang="scss">
.teach-container {
    &, & * {
        box-sizing: border-box;
    }
    width: 100%;
    height: calc(100vh - 70px);
    padding: 20px 0;
    .container {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        background-color: #fff;
        padding: 10px 20px;
        &:deep(.resources-content) {
            &, & * {
                box-sizing: border-box;
            }
            height: 100%;
            display: flex;
            flex-direction: column;
            .el-tabs__content {
                height: 0;
                flex: 1;
                .el-tab-pane {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    .course-list {
        height: 40px;
        padding-left: 10px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 10px;
    }
}

</style>
